import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import * as routes from "./Data/Routes";
import Error from "./Components/Error";
import { CustomSoftwareDev } from "./Screens/CustomSoftwareDev";
import { MobileAppDev } from "./Screens/MobileAppDev";
import { WebAppServices } from "./Screens/WebAppServices";
import { UxReviewAnalysis } from "./Screens/UxReviewAnalysis";
import { UxDesign } from "./Screens/UxDesign";
import { UiDesign } from "./Screens/UiDesign";
import { OtherServices } from "./Screens/OtherServices";
import { NewHome } from "./Screens/NewHome";
import { NewHeader } from "./Components/NewHeader";
import { NewFooter } from "./Components/NewFooter";
import { ProductDesign } from "./Screens/ProductDesign";
import { MeetTheTeam } from "./Screens/MeetTheTeam";
// import { Home } from "./Screens/Home";
// import { Header } from "./Components/Header";
// import { Footer } from "./Components/Footer";

function App() {
  return (
    <BrowserRouter>
      <NewHeader />
      {/* <Header /> */}
      <Routes>
        <Route path={routes.homepage} index element={<NewHome />} />
        {/* <Route path={routes.homepage} index element={<Home />} /> */}
        <Route
          path={routes.custSoftDev}
          index
          element={<CustomSoftwareDev />}
        />
        <Route path={routes.webAppServ} index element={<WebAppServices />} />
        <Route path={routes.productDesign} index element={<ProductDesign />} />
        <Route path={routes.meetTheTeam} index element={<MeetTheTeam />} />
        <Route path={routes.mobileAppDev} index element={<MobileAppDev />} />
        <Route path={routes.uxRevAnaly} index element={<UxReviewAnalysis />} />
        <Route path={routes.uxDesign} index element={<UxDesign />} />
        <Route path={routes.uiDesign} index element={<UiDesign />} />
        <Route path={routes.uxOtherServ} index element={<OtherServices />} />
        <Route path="*" element={<Error />}></Route>
      </Routes>
      <NewFooter />
      {/* <Footer /> */}
    </BrowserRouter>
  );
}

export default App;
